import React from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";
import MenuHeader from "./menuHeader";
import { useRecoilState } from "recoil";
import { tokenState, userState } from "../reducer/recoil";
const { width, height } = Dimensions.get("window");
export default function header({ navigation }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [user, setUser] = useRecoilState(userState);
  function Logout() {
    setToken("");
    setUser("");
    setTimeout(() => {
      navigation.navigate("Login");
    }, 200);
  }
  return (
    <View
      style={{
        height: height,
        width: "100%",
        backgroundColor: "#2B6AB1",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          borderBottomWidth: 1,
          borderColor: "#FFFFFF",
          marginHorizontal: 10,
          paddingVertical: 10,
        }}
      >
        <Image
          resizeMode={"contain"}
          style={{ width: 89, height: 86 }}
          source={require("../img/logo4.png")}
        />
        <Text
          style={{
            fontSize: 20,
            fontFamily: "Prompt",
            color: "#FFFFFF",
            marginLeft: 10,
          }}
        >
          {"ASIAN ATHLETICS\nASSOCIATION"}
        </Text>
      </View>
      <View
        style={{
          borderBottomWidth: 1,
          borderBottomColor: "#FFFFFF",
          paddingVertical: 30,
          marginHorizontal: 10,
        }}
      >
        <MenuHeader
          onPress={() => {
            navigation.navigate("Home");
          }}
          Title="HOME"
          source={require("../img/home white.png")}
          style={{ width: 35, height: 28 }}
        />
        <MenuHeader
          onPress={() => {
            navigation.navigate("Competition");
          }}
          Title="COMPETITIONS"
          source={require("../img/sc White.png")}
          style={{ width: 29, height: 32 }}
        />
        <MenuHeader
          onPress={() => {
            navigation.navigate("Athlete");
          }}
          Title="ATHLETE"
          source={require("../img/Person White.png")}
          style={{ width: 39, height: 29 }}
        />
        <MenuHeader
          onPress={() => {
            navigation.navigate("Countries");
          }}
          Title="COUNTRIES"
          source={require("../img/world white.png")}
          style={{ width: 43, height: 43 }}
        />
      </View>
      <View style={{ marginHorizontal: 10 }}>
        <MenuHeader
          onPress={Logout}
          Title="LOG OUT"
          source={require("../img/Exit White.png")}
          style={{ width: 39, height: 35 }}
        />
      </View>
    </View>
  );
}
